import TableCellDescription from "ds/components/Table/Row/CellDescription";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useAnalytics from "hooks/useAnalytics";
import {
  SharedModuleDataWithSpace,
  SharedModuleDataWithAccount,
} from "views/Account/SharedModulesNew/types";

const SharedModulesTableDescriptionCell = ({
  item: sharedModule,
  ...cellProps
}: TableSimpleCellProps<SharedModuleDataWithSpace | SharedModuleDataWithAccount>) => {
  const trackAnalytics = useAnalytics();

  const handleShowFullDescription = () => {
    trackAnalytics("Show full description clicked");
  };

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription
        description={sharedModule.description}
        onShowFullDescription={handleShowFullDescription}
      />
    </TableSimpleCell>
  );
};

export default SharedModulesTableDescriptionCell;
